import React, { useState, useEffect } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateFinishBonus = ({ onFinishBonusCreated}) => {
  const [formData, setFormData] = useState({
    slug: "",
    header_title: "",
    header_icon: "",
    bonuses: [{ icon: "", title: "", description: "" }]
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleBonusChange = (index, e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updatedBonuses = [...prev.bonuses];
      updatedBonuses[index] = { ...updatedBonuses[index], [name]: value };
      return { ...prev, bonuses: updatedBonuses };
    });
  };

  const handleAddBonus = () => {
    setFormData(prev => ({
      ...prev,
      bonuses: [...prev.bonuses, { icon: "", title: "", description: "" }]
    }));
  };

  const handleRemoveBonus = (index) => {
    if (formData.bonuses.length > 1) {
      setFormData(prev => ({
        ...prev,
        bonuses: prev.bonuses.filter((_, i) => i !== index)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
    
        // Update existing header
        const response = await axios.post(`${apiUrl}/finishbonuses`, formData);
    

      if (onFinishBonusCreated) {
        onFinishBonusCreated();
      }
      
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || `An error occurred while creating the Finish Bonus Header.`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">
        Create Finish Bonus Header
      </h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., finish-bonuses"
          />
        </div>

        <div>
          <label className="block mb-1">Header Title:</label>
          <input
            type="text"
            name="header_title"
            value={formData.header_title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., Our Finish Bonuses"
          />
        </div>

        <div>
          <label className="block mb-1">Header Icon:</label>
          <input
            type="text"
            name="header_icon"
            value={formData.header_icon}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., fas fa-gift"
          />
        </div>

        <div className="border-t pt-4 mt-4">
          <h3 className="text-lg font-semibold mb-3">Bonuses</h3>
          
          {formData.bonuses.map((bonus, index) => (
            <div key={index} className="mb-4 p-3 border rounded bg-gray-50 space-y-3">
              <div className="flex justify-between items-center">
                <h4 className="font-medium">Bonus #{index + 1}</h4>
                {formData.bonuses.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveBonus(index)}
                    className="text-red-500 hover:text-red-700"
                  >
                    Remove
                  </button>
                )}
              </div>

              <div>
                <label className="block mb-1">Icon:</label>
                <input
                  type="text"
                  name="icon"
                  value={bonus.icon}
                  onChange={(e) => handleBonusChange(index, e)}
                  className="w-full p-2 border rounded"
                  placeholder="e.g., fas fa-check"
                  required
                />
              </div>

              <div>
                <label className="block mb-1">Title:</label>
                <input
                  type="text"
                  name="title"
                  value={bonus.title}
                  onChange={(e) => handleBonusChange(index, e)}
                  className="w-full p-2 border rounded"
                  placeholder="e.g., Free Support"
                  required
                />
              </div>

              <div>
                <label className="block mb-1">Description:</label>
                <textarea
                  name="description"
                  value={bonus.description}
                  onChange={(e) => handleBonusChange(index, e)}
                  className="w-full p-2 border rounded"
                  rows="2"
                  placeholder="e.g., Get 24/7 support for your project"
                  required
                ></textarea>
              </div>
            </div>
          ))}

          <button
            type="button"
            onClick={handleAddBonus}
            className="px-4 py-2 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
          >
            Add Another Bonus
          </button>
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting 
            ? "Submitting...": "Create Header"}
        </button>
      </form>
    </div>
  );
};

export default CreateFinishBonus;